import { createSlice } from "@reduxjs/toolkit";
import * as warehouseActions from "./warehouseActions";

const InitialState = {
    isLoading: false,
    warehouse_details: [],
    hasError: false,
};

const warehouseReducer = createSlice({
    name: "warehouse_details",
    initialState: InitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(warehouseActions.getWarhouseDetails.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(warehouseActions.getWarhouseDetails.fulfilled, (state, action) => {
                state.warehouse_details = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(warehouseActions.getWarhouseDetails.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
    },
});

export default warehouseReducer.reducer;